module.exports = __webpack_public_path__ + "img/電気回路_4_1_4.e0312630.png";